import { gql } from '@apollo/client';
import { Form, Input } from 'antd';
import SettingsDrawer from 'components/Settings/SettingsDrawer';
import { useMutation } from 'hooks/apollo';
import React, { useEffect } from 'react';
import { SURVEY_TEMPLATE_SETTINGS } from 'shared/constants/settings';

const UPDATE = gql`
  mutation UpdateSurveyCategory($id: ID!, $title: String!) {
    updateSurveyCategory(id: $id, title: $title) {
      id
      title
    }
  }
`;

const CREATE = gql`
  mutation CreateSurveyCategory($title: String!) {
    createSurveyCategory(title: $title) {
      id
      title
    }
  }
`;

const EditSurveyCategoryForm = ({ category, onCancel, onCreate }) => {
  const [form] = Form.useForm();
  const [updateCategory] = useMutation(UPDATE);
  const [createCategory] = useMutation(CREATE);

  useEffect(() => {
    if (category) {
      form.resetFields();
    }
  }, [category]);

  const onSubmit = async (values) => {
    let { id } = category;
    if (id) {
      await updateCategory({ variables: { id: category.id, ...values } });
      onCancel();
    } else {
      const res = await createCategory({ variables: { ...values } });
      id = res.data.createSurveyCategory.id;
      onCreate();
    }

    return id;
  };

  return (
    <SettingsDrawer
      relationId={category.id}
      settings={SURVEY_TEMPLATE_SETTINGS}
      initialValues={category}
      title="Edit industry"
      open={!!category}
      onCancel={onCancel}
      onDone={onCancel}
      onSubmit={onSubmit}
    >
      <Form.Item name="title" label="Title" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
    </SettingsDrawer>
  );
};

export default EditSurveyCategoryForm;
